var T = Object.defineProperty;
var b = (n, t, e) => t in n ? T(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var i = (n, t, e) => b(n, typeof t != "symbol" ? t + "" : t, e);
import { defineComponent as L, watch as x, createBlock as _, openBlock as p, unref as E, withCtx as k, createElementBlock as R, Fragment as O, renderList as v, normalizeClass as N, toDisplayString as P } from "vue";
import { l as D, i as U, s as S, D as K, a as M, _ as z } from "./main-gkH8anpp.mjs";
import B from "@constructor-io/constructorio-client-javascript";
import { S as F } from "./SearchListbox-DSTzQqA0.mjs";
const W = (n, t = 300, e = 1e3) => {
  let s, r, o, l, a = 0;
  const h = () => {
    s && clearTimeout(s), r && clearTimeout(r), s = void 0, r = void 0;
  }, g = (A, m) => {
    h(), a = Date.now(), Promise.resolve(n.apply(l, o)).then(A).catch(m);
  };
  return function(...m) {
    o = m, l = this;
    const I = Date.now();
    a === 0 && (a = I);
    const C = I - a;
    return new Promise((d, f) => {
      if (C >= e) {
        g(d, f);
        return;
      }
      s && clearTimeout(s), s = setTimeout(() => g(d, f), t), r || (r = setTimeout(() => g(d, f), e - C));
    });
  };
}, q = (n) => [
  // ...fetchFailMsgList,
  // https://constructor-io.github.io/constructorio-client-javascript/modules_autocomplete.js.html#line210
  "getAutocompleteResults response data is malformed"
].includes(n == null ? void 0 : n.message), c = class c {
  constructor(t, e) {
    /**
     * A Constructor apiKey is a workspace index key
     * that maps to a particular environment or context. (not considered secret)
     * https://app.constructor.io/dashboard/indexes
     * @private
     */
    i(this, "apiKey");
    /**
     * Remote Constructor API service endpoint
     * https://constructor-io.github.io/constructorio-client-javascript/ConstructorIO.html
     * @private
     */
    i(this, "serviceUrl");
    /** See type interface for info */
    i(this, "c9rConfig");
    /**
     * Constructor.io JavaScript client (external/third-party)
     * https://constructor-io.github.io/constructorio-client-javascript/index.html
     * @private
     */
    i(this, "constructorIO");
    /**
     * Tracks number of errors logged and is used as a check against spamming Datadog
     * if a repetitive error condition is reached with some allowance for optional retry
     * but largely due to the high frequency nature of autosuggest UI keyboard input behavior.
     * @private
     */
    i(this, "loggedErrorCount");
    /**
     * REI CIAM user id, if available due to user being logged in.
     * https://rei-coop.atlassian.net/wiki/spaces/OC/pages/4786229/Customer+Identity+and+Access+Management+CIAM+Overview
     * @private
     */
    i(this, "userId");
    if (c.instance)
      throw new Error("Use AutoSuggestClient.getInstance() to access the singleton instance.");
    this.initProperties(t, e);
  }
  /**
   * Initializes instance properties during class construction
   * @param {string} apiKey Constructor API index reference
   * @param {string} serviceUrl Remote Constructor API service endpoint
   * @private
   * @return {void}
   */
  initProperties(t, e) {
    this.apiKey = t, this.serviceUrl = e, this.c9rConfig = {
      resultsPerSection: {
        "Search Suggestions": 10
      }
    }, this.constructorIO = null, this.loggedErrorCount = 0, this.userId = null, c.instance = this;
  }
  /**
   * Getter and factory method for Constructor third-party API client that holds autocomplete module
   * @private
   * @return Promise<ConstructorIO>
   */
  async getC9rClientInstance() {
    if (!this.constructorIO) {
      const t = await w.getOnlineAccountNumber();
      this.userId = t || null, this.constructorIO = new B({
        apiKey: this.apiKey,
        serviceUrl: this.serviceUrl,
        userId: this.userId
      });
    }
    return this.constructorIO;
  }
  /**
   * Getter and singleton factory method for this class
   * @param {string} apiKey Constructor API index reference
   * @param {string} serviceUrl Remote Constructor API service endpoint
   */
  static getInstance(t, e) {
    return c.instance || (c.instance = new c(
      t,
      e
    )), c.instance;
  }
  /**
   * Main autocomplete/autosuggest results getter with no error logging.
   * that initializes external ConstructorIO client on first attempt.
   * Public access deprecated in favor of `getAutosuggestResultsWithErrLogAndRetry`.
   * @param {string} searchTerm
   * @param {C9rResultsConfig} resultsConfig
   */
  async getAutosuggestResults(t, e = this.c9rConfig) {
    return (await this.getC9rClientInstance()).autocomplete.getAutocompleteResults(t, e);
  }
  /**
   * Preferred main autocomplete/autosuggest results getter that wraps getAutosuggestResults
   * and offers limited logging and an optional retry for certain error patterns.
   * @param {string} searchTerm
   * @param {C9rResultsConfig} resultsConfig
   * @param {{ count: number, limit: number }} retryConfig
   * @return {unknown}
   */
  async getAutosuggestResultsWithErrLogAndRetry(t, e, s = { count: 0, limit: 0 }) {
    let r;
    try {
      r = await this.getAutosuggestResults(t, e);
    } catch (o) {
      const { count: l, limit: a } = s, h = {
        source: "getAutosuggestResultsWithErrLogAndRetry",
        isErrorRetryable: q(o),
        resultsConfig: e,
        retryConfig: s,
        searchTerm: t
      };
      if (this.resolveError(o, h), h.isErrorRetryable && a && l < a) {
        const g = { ...s };
        g.count += 1, r = await this.getAutosuggestResultsWithErrLogAndRetry(t, e, g);
      }
    }
    return r;
  }
  /**
   * Provides wrapper for logging errors using logger util and provides:
   * - A limit guard for logging to allow a single log per session/instance
   *   that is padded for any retry limit for the first error
   * - Common context data that is shared by any error in this class
   * @param {Error | unknown} error
   * @param {object} context
   * @private
   * @return {void}
   */
  resolveError(t, e) {
    const { retryConfig: { limit: s = 0 } } = e || {};
    if (this.loggedErrorCount < s + 1) {
      const { apiKey: r, serviceUrl: o, userId: l } = this;
      D(t, {
        ...e,
        source: `AutosuggestClient.${e.source}`,
        apiKey: r,
        serviceUrl: o,
        userId: l,
        vendor: "C9r"
      }), this.loggedErrorCount += 1;
    }
  }
};
i(c, "instance");
let y = c;
const H = async (n, t) => y.getInstance(
  // apiKey is index key, not considered secret
  // https://app.constructor.io/dashboard/indexes
  "key_9Mi6wJ14xYHiFlPx",
  "https://ezeubuswo-zone.cnstrc.com/"
).getAutosuggestResultsWithErrLogAndRetry(
  n,
  t
), u = class u {
  /**
   * Get the singleton instance of UserService
   */
  static getInstance() {
    return u.instance || (u.instance = new u()), u.instance;
  }
  /**
   * Gets the online account number from utag_data or by API call
   * @returns A promise that resolves to the online account number or null
   */
  static async getOnlineAccountNumber() {
    const t = window == null ? void 0 : window.utag_data, { isLoggedIn: e, onlineAccountNumber: s } = t || {};
    if (e === "logged in" && s)
      return s;
    if (!t) {
      const r = await u.fetchUser();
      return typeof (r == null ? void 0 : r.accountId) == "string" ? r.accountId : null;
    }
    return null;
  }
  /**
   * Fetches user data from the API
   * @returns A promise that resolves to user data or null
   */
  static async fetchUser() {
    try {
      const t = await fetch("/rest/user/account");
      return t.ok ? await t.json() : null;
    } catch {
      return null;
    }
  }
};
i(u, "instance");
let w = u;
const J = /* @__PURE__ */ L({
  __name: "SearchAutosuggest",
  setup(n) {
    const t = W(H, 70, 700);
    return x(() => U.cleanQuery, async (e) => {
      if (!e) {
        S({});
        return;
      }
      const s = await t(e);
      S(s);
    }), (e, s) => (p(), _(F, {
      suggestions: E(M).autosuggestSearchSuggestions,
      "c9r-section": E(K)
    }, {
      default: k(({
        item: r
      }) => [(p(!0), R(O, null, v(r.termParts, (o) => (p(), R("span", {
        key: o.key,
        class: N(["search-autosuggest__item-part", {
          "search-autosuggest__item-part--query-text": o.queryText
        }])
      }, P(o.text), 3))), 128))]),
      _: 1
    }, 8, ["suggestions", "c9r-section"]));
  }
}), X = /* @__PURE__ */ z(J, [["__scopeId", "data-v-973608f1"]]);
export {
  X as default
};
